"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagEU = function FlagEU(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H-185.94A7.07,7.07,0,0,1-193,139.3V-114.94a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14.67-91.27l2.83,8.49,9,.07a1.2,1.2,0,0,1,.71,2.17L20-75.22l2.7,8.53a1.21,1.21,0,0,1-1.85,1.35l-7.28-5.21L6.25-65.34a1.21,1.21,0,0,1-1.86-1.35l2.7-8.53-7.2-5.32A1.2,1.2,0,0,1,.6-82.71l9-.07,2.83-8.49a1.21,1.21,0,0,1,2.29,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14.67,91l2.83,8.49,9,.07a1.2,1.2,0,0,1,.71,2.17L20,107.07l2.7,8.53A1.21,1.21,0,0,1,20.81,117l-7.28-5.21L6.25,117a1.21,1.21,0,0,1-1.86-1.35l2.7-8.53-7.2-5.32A1.2,1.2,0,0,1,.6,99.58l9-.07L12.38,91a1.21,1.21,0,0,1,2.29,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M105.82-.13l2.83,8.49,8.95.07a1.21,1.21,0,0,1,.7,2.18l-7.2,5.32,2.7,8.53A1.2,1.2,0,0,1,112,25.8l-7.28-5.2-7.28,5.2a1.2,1.2,0,0,1-1.85-1.34l2.7-8.53L91,10.61a1.21,1.21,0,0,1,.71-2.18l8.94-.07,2.84-8.49a1.21,1.21,0,0,1,2.29,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-76.47-.13l2.83,8.49,9,.07A1.21,1.21,0,0,1-64,10.61l-7.2,5.32,2.7,8.53a1.21,1.21,0,0,1-1.86,1.34l-7.28-5.2-7.28,5.2a1.2,1.2,0,0,1-1.85-1.34l2.7-8.53-7.2-5.32a1.21,1.21,0,0,1,.71-2.18l9-.07,2.83-8.49a1.21,1.21,0,0,1,2.29,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-62.79-47.72-60-39.24l9,.08A1.2,1.2,0,0,1-50.3-37l-7.2,5.32,2.7,8.53a1.21,1.21,0,0,1-1.85,1.35L-63.93-27l-7.29,5.21a1.21,1.21,0,0,1-1.85-1.35l2.7-8.53L-77.57-37a1.2,1.2,0,0,1,.71-2.17l9-.08,2.83-8.48a1.21,1.21,0,0,1,2.29,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M95.08,43.42l2.83,8.49,9,.07a1.21,1.21,0,0,1,.71,2.18l-7.2,5.31,2.7,8.54a1.21,1.21,0,0,1-1.86,1.34l-7.28-5.21-7.28,5.21A1.2,1.2,0,0,1,84.8,68l2.7-8.54-7.2-5.31A1.21,1.21,0,0,1,81,52L90,51.91l2.83-8.49a1.21,1.21,0,0,1,2.29,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M61.71-81.09l2.84,8.5,9,.06a1.21,1.21,0,0,1,.7,2.18L67-65l2.7,8.53a1.2,1.2,0,0,1-1.85,1.34l-7.28-5.2-7.28,5.2a1.2,1.2,0,0,1-1.85-1.34L54.14-65l-7.2-5.32a1.21,1.21,0,0,1,.7-2.18l9-.06,2.83-8.5a1.2,1.2,0,0,1,2.28,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-29.43,76.78l2.83,8.49,9,.07a1.21,1.21,0,0,1,.71,2.18l-7.2,5.32,2.7,8.53a1.2,1.2,0,0,1-1.85,1.34l-7.28-5.2-7.29,5.2a1.2,1.2,0,0,1-1.85-1.34l2.7-8.53-7.2-5.32a1.21,1.21,0,0,1,.71-2.18l9-.07,2.83-8.49a1.21,1.21,0,0,1,2.29,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M92.79-47.72,90-39.24,81-39.16A1.2,1.2,0,0,0,80.3-37l7.2,5.32-2.7,8.53a1.21,1.21,0,0,0,1.85,1.35L93.93-27l7.28,5.21a1.21,1.21,0,0,0,1.86-1.35l-2.7-8.53,7.2-5.32a1.2,1.2,0,0,0-.71-2.17l-9-.08-2.83-8.48a1.21,1.21,0,0,0-2.29,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-65.08,43.42l-2.83,8.49-9,.07a1.21,1.21,0,0,0-.71,2.18l7.2,5.31L-73.07,68a1.2,1.2,0,0,0,1.85,1.34l7.29-5.21,7.28,5.21A1.2,1.2,0,0,0-54.8,68l-2.7-8.54,7.2-5.31A1.21,1.21,0,0,0-51,52l-9-.07-2.83-8.49a1.21,1.21,0,0,0-2.29,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-31.72-81.09l-2.83,8.5-9,.06a1.21,1.21,0,0,0-.71,2.18L-37-65l-2.7,8.53a1.2,1.2,0,0,0,1.85,1.34l7.29-5.2,7.28,5.2a1.2,1.2,0,0,0,1.85-1.34L-24.14-65l7.2-5.32a1.21,1.21,0,0,0-.71-2.18l-9-.06-2.83-8.5a1.21,1.21,0,0,0-2.29,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M59.43,76.78l-2.84,8.49-9,.07a1.21,1.21,0,0,0-.7,2.18l7.2,5.32-2.7,8.53a1.2,1.2,0,0,0,1.85,1.34l7.28-5.2,7.28,5.2a1.2,1.2,0,0,0,1.85-1.34L67,92.84l7.2-5.32a1.21,1.21,0,0,0-.7-2.18l-9-.07-2.84-8.49a1.2,1.2,0,0,0-2.28,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagEU;
exports["default"] = _default;